// extracted by mini-css-extract-plugin
export default {"content":"CancelModal_content__eOKuP","text":"CancelModal_text__T5VJd","btnsCont":"CancelModal_btnsCont__Sspx8"};